<div class="align-self-center type-info-container" [ngClass]="typeInfo.classId"
  [style.--color]="typeInfo.color" *ngIf="typeInfo">
  <div class="icon">
    <ion-icon name="fast-food-outline" *ngIf="typeInfo.id === 'DINE_IN'"></ion-icon>
    <ion-icon name="bicycle-outline" *ngIf="typeInfo.id === 'DELIVERY'"></ion-icon>
    <ion-icon name="bag-check-outline" *ngIf="typeInfo.id === 'TAKEAWAY'"></ion-icon>
  </div>
  <div class="label">
    <span [innerText]="typeInfo.label"></span>
  </div>
</div>
